// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>4</span>&nbsp;&nbsp;Children are a heritage from the Lord&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and the fruit of the womb is his gift.<br> </p> </div></div>";
// Exports
module.exports = code;